import React, { Component } from 'react';
import NavBigScreen from '../../../containers/NavBigScreen';
import NavCollapse from '../../../containers/NavCollapse';
import NavSmallScreen from '../../../containers/NavSmallScreen';
import type { User } from '../../../types';

type Props = {
  navigate: any,
  currentUser: User,
  onPayrollGeneratorClick?: Function,
  onMarketingStatsClick?: Function,
}

class MainNav extends Component<Props, any> {
  render(): React.ReactNode {
    const { navigate, onPayrollGeneratorClick, onMarketingStatsClick } = this.props;

    return (
      <>
        <NavBigScreen
          navigate={navigate}
          onPayrollGeneratorClick={onPayrollGeneratorClick}
          onMarketingStatsClick={onMarketingStatsClick}
        />
        <NavSmallScreen
          navigate={navigate}
        />
        <NavCollapse
          onPayrollGeneratorClick={onPayrollGeneratorClick}
          onMarketingStatsClick={onMarketingStatsClick}
        />
      </>
    );
  }
}

export default MainNav;
